import React from "react";
import { Link, useParams } from "react-router-dom";
import PublicNavbar from "../components/PublicNavbar";
import PublicFooter from "../components/PublicFooter";
import { CheckCircle2, Copy, Search, ArrowRight } from "lucide-react";
import { toast } from "sonner";

export default function ReportSuccessPage() {
  const { nomor } = useParams();

  const copy = () => {
    navigator.clipboard.writeText(nomor);
    toast.success("Nomor laporan disalin");
  };

  return (
    <div data-testid="report-success-page" className="min-h-screen bg-slate-50 flex flex-col">
      <PublicNavbar />
      <main className="flex-1 flex items-center justify-center py-16 px-4">
        <div className="max-w-xl w-full">
          <div className="rounded-xl bg-white border border-slate-200 shadow-police p-10 reveal-up">
            <div className="mx-auto h-16 w-16 rounded-full bg-emerald-50 border-4 border-emerald-100 flex items-center justify-center">
              <CheckCircle2 className="h-8 w-8 text-emerald-600" />
            </div>
            <h1 className="mt-6 text-center font-display font-black text-3xl tracking-tight text-[#0F172A]">
              Laporan Berhasil Dikirim
            </h1>
            <p className="mt-3 text-center text-slate-600 leading-relaxed">
              Terima kasih atas kepedulian Anda. Petugas Ditresnarkoba Polda Jateng akan
              segera memverifikasi laporan ini.
            </p>
            <div className="mt-8 rounded-lg bg-slate-50 border border-slate-200 p-5">
              <div className="text-[10px] tracking-[0.24em] uppercase font-semibold text-slate-500 text-center">
                Nomor Laporan Anda
              </div>
              <div
                data-testid="nomor-laporan-display"
                className="mt-2 font-mono-tight font-bold text-2xl text-[#0B2B5E] text-center"
              >
                {nomor}
              </div>
              <button
                onClick={copy}
                data-testid="copy-nomor-btn"
                className="mt-3 w-full inline-flex items-center justify-center gap-2 rounded-md border border-slate-200 bg-white px-4 py-2 text-xs font-semibold text-slate-700 hover:bg-slate-100"
              >
                <Copy className="h-3.5 w-3.5" />
                Salin Nomor
              </button>
            </div>
            <div className="mt-6 text-xs text-slate-500 bg-amber-50 border border-amber-200 rounded-md p-3">
              <strong className="text-amber-800">Simpan baik-baik</strong> nomor di atas
              untuk melacak status laporan Anda.
            </div>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <Link
                to={`/lacak?nomor=${nomor}`}
                data-testid="track-now-btn"
                className="flex-1 inline-flex items-center justify-center gap-2 rounded-md bg-[#0B2B5E] text-white px-5 py-3 text-sm font-semibold hover:bg-[#081f47] transition-colors"
              >
                <Search className="h-4 w-4" />
                Lacak Status
              </Link>
              <Link
                to="/"
                data-testid="back-home-btn"
                className="flex-1 inline-flex items-center justify-center gap-2 rounded-md border border-slate-300 bg-white px-5 py-3 text-sm font-semibold text-slate-700 hover:bg-slate-50"
              >
                Kembali ke Beranda
                <ArrowRight className="h-4 w-4" />
              </Link>
            </div>
          </div>
        </div>
      </main>
      <PublicFooter />
    </div>
  );
}
